import { Box, Button, Pagination, Select, MenuItem, Typography, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { DeleteNodeChildModel } from "../deleteNodeChildModel";
import DeleteModal from "../delete_modal";
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import { EditBranches } from "./EditBranches";
import { toast } from "react-toastify";
import { selectnodess } from "../../redux/nodesSlice";
import LoadingOverlay from "../../mui/LoadingOverlay";
import { ShowBranchesModel } from "../showBranchesModal";
import TableMuiCustom from "../../mui/TableMuiCustom";
import { selectAdmin, selectDevice } from "../../redux/adminSlice";
import WarningModal from "../WarningModal";
import { orgwarndata } from "../../redux/websocketSlice";
import { useDeleteOrganizationMutation, useUpdateOrganizationMutation } from "../../redux/organizationApi";

function Branches() {
    const warndata = useSelector(orgwarndata);
    const deviceId = useSelector(selectDevice);
    const [loading, setLoading] = useState(true);
    const [datafordelete, setdatafordelete] = useState([]);
    const admin = useSelector(selectAdmin);
    const [showBranch, setshowBranch] = useState(false);
    const [sharedata, setSharedata] = useState(0);
    const [node, setnode] = useState({});
    const [node1, setnode1] = useState({});
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openDeleteModal1, setOpenDeleteModal1] = useState(false);


    const [deleteopen, setDeleteopen] = useState(false);
    const navigate = useNavigate();
    const [errors, setErrors] = useState({
        general: {},
        shareholders: [],
        directors: [],
        additionalFields: []

    });

    const [searchQuery, setSearchQuery] = useState('');
    const [open, setOpen] = useState(false);

    const [sortKey, setSortKey] = useState("companyName");
    const [sortOrder, setSortOrder] = useState("asc");
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const dispatch = useDispatch();
    const [updateOrganization, { isLoading: isUpdating }] = useUpdateOrganizationMutation();
    const [deleteOrganization, { isLoading: isDeleting }] = useDeleteOrganizationMutation();
    const initialNode = {
        companyName: "",
        location: {
            name: "", address: "", lat: "", lng: "", countryName: ""
        },
        totalNoOfShares: 0,
        directors: [""],
        shareHolders: [
            {
                childId: "",
                numberSharesOwned: "",
                PercentageOfShares: 0,
            },
        ],
        BusinessNature: "",
        Incorporationdate: "",
        CompanyRegistrationNumber: "",
        BusinessRegistrationNumber: "",
        ManagingDirector: "",
        DeputyManagingDirector: "",
        Chairman: "",
        DeputyChairman: "",
        CompanySecretary: "",
        BusinessGroup: '',
        StatutoryAuditor: "",
        RepresentativeDirector: "",
        LegalRepresentative: "",
        TotalPaidUpCapital: "",
        Remarks: "",
        ParValueofShares: "",
        TotalPaidUpPremiumtoShares: ""
    };
    const [nodeData, setNodeData] = useState(initialNode);
    const allorganization = useSelector(selectnodess) || [];
    const [parentOptions, setParentOptions] = useState([]);
    const [childOrganizations, setChildOrganizations] = useState([]);

    useEffect(() => {
        setLoading(false);
    }, [allorganization?.length]);
    useEffect(() => {
        const mainorganization = Array.isArray(allorganization) && allorganization.filter((item) => item.isBranch === false && !item.data?.jointcompany) || [];
        const parents = mainorganization.map((org) => {
            return {
                label: org.data?.label,
                value: org.id?.toString(),
            };
        });
        setParentOptions(parents || []);
    }, [allorganization]);

    const validateInput = () => {
        const errorObject = {

            additionalFields: [],
        };



        // Validate Additional Fields
        nodeData?.additionalFields?.forEach((obj, index) => {
            const errorsdata = {};
            if (obj?.fieldName.trim() === "") {
                errorsdata.fieldName = "Field name is required";
            }
            if (obj?.fieldValue.trim() === "") {
                errorsdata.fieldValue = "Field value is required";
            }
            errorObject.additionalFields[index] = errorsdata;
        });


        setErrors(errorObject);

        return (

            errorObject.additionalFields.every((e) => Object.keys(e).length === 0)
        );
    };



    useEffect(() => {
        const currentRoot = Array.isArray(allorganization) && allorganization.filter((org) => org.isBranch === true);
        const data = Array.isArray(currentRoot) && currentRoot?.map((item) => ({
            ...item,
        })) || [];
        setChildOrganizations(data);
    }, [allorganization]);

    const handleClose = () => {
        setOpen(false);
        dispatch({
            type: "alertremove", payload: {
                id: nodeData._id || nodeData?.nodeId,
                message: "Another users also edit this business group"
            }
        })
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setNodeData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setNodeData((prevData) => ({
            ...prevData,
            imageFile: file,
            preview: URL.createObjectURL(file),
        }));
    };
    const handelDirector = (index, name) => {
        const newNames = [...nodeData.directors];
        newNames[index] = name;
        setNodeData((prev) => ({ ...prev, directors: newNames }));
    };
    const handleAddDirector = () => {
        setNodeData((prev) => ({ ...prev, directors: [...prev.directors, ""] }));
    };
    const handelAddShareHolder = () => {
        setNodeData((prev) => ({
            ...prev,
            shareHolders: [
                ...prev.shareHolders,
                {
                    companyName: "",
                    totalNoOfShares: "",
                    PercentageOfShares: 0,
                },
            ],
        }));
    };
    const handleShareHolders = (index, field, value) => {
        const updatedShareHolders = [...nodeData.shareHolders];
        updatedShareHolders[index] = {
            ...updatedShareHolders[index],
            [field]: value,
        };
        if (field === "totalNoOfShares" && nodeData.totalNoOfShares > 0) {
            updatedShareHolders[index].PercentageOfShares =
                (value / nodeData.totalNoOfShares) * 100;
        }
        setNodeData((prev) => ({ ...prev, shareHolders: updatedShareHolders }));
    };
    const handleTotalSharesChange = (e) => {
        const { value } = e.target;
        const totalShares = parseFloat(value);
        setSharedata(totalShares);
        setNodeData((prevData) => {
            const updatedShareHolders = prevData.shareHolders?.map((sh) => ({
                ...sh,
                PercentageOfShares:
                    totalShares > 0 ? (sh.numberSharesOwned / totalShares) * 100 : 0,
            }));
            return {
                ...prevData,
                totalNoOfShares: totalShares,
                shareHolders: updatedShareHolders,
            };
        });
    };
    const handleSubmit = async () => {
        if (!validateInput()) {
            return;
        }
        try {
            setOpen(false);
            await updateOrganization({
                id: nodeData.nodeId,
                data: nodeData,
            }).unwrap();
            toast.success("Branch company updated successfully");
            if (deleteopen) {
                setOpenDeleteModal(true);
            }
        } catch (error) {
            console.error("Error updating node:", error);
            toast.error(
                error?.data?.message || error?.error || "Failed to update node"
            );
        }
    };
    const deleteData = async () => {
        try {
            setOpen(false);
            await deleteOrganization({ id: node.nodeId, isRoot: false }).unwrap();
            setDeleteopen(false);
            toast.success("Branch is deleted successfully");
        } catch (error) {
            console.error("Error delete node:", error);
            toast.error(
                error?.data?.message || error?.error || "Failed to delete branch"
            );
        }
    };
    const handleSearchChange = (event) => {
        const query = event.target.value;
        setSearchQuery(query);
        const currentRoot = allorganization?.filter((org) => org.isBranch === true) || [];

        if (query !== "") {
            const filtered = currentRoot.filter((org) =>
                org.data?.companyName?.toLowerCase().includes(query.toLowerCase())
            );
            setChildOrganizations(filtered);
        } else {
            setChildOrganizations(currentRoot);
        }
    };
    const handleSortChange = (key) => {
        if (sortKey === key) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortKey(key);
            setSortOrder("asc");
        }
    };
    const sortedOrganizations = [...(childOrganizations || [])].sort((a, b) => {
        const valA = sortKey === "totalNoOfShares" ? parseFloat(a.data?.[sortKey]) : a.data?.[sortKey];
        const valB = sortKey === "totalNoOfShares" ? parseFloat(b.data?.[sortKey]) : b.data?.[sortKey];

        if (sortOrder === "asc") {
            return valA > valB ? 1 : -1;
        } else {
            return valA < valB ? 1 : -1;
        }
    });
    const total = sortedOrganizations?.length || 0;
    const paginatedOrganizations = sortedOrganizations?.slice((page - 1) * pageSize, page * pageSize);

    const enrichedOrganizations = paginatedOrganizations?.map((org, index) => {

        return {
            ...org,
            data: {
                ...(org.data || {}),
                index: (page - 1) * pageSize + index + 1,
                directors: Array.isArray(org.data?.directors) ? org.data.directors.join(",") : "",
                directorsLength: Array.isArray(org.data?.directors) ? org.data.directors.length : 0,
                shareHoldersLength: Array.isArray(org.data?.shareHolders) ? org.data.shareHolders.length : 0,
                BusinessGroupEntity: org?.data?.BusinessGroupEntity?.businessNature || "N/A"
            },
        };
    });

    return (
        <>
            <div>
                <div className="add-new d-flex align-items-end justify-content-end"></div>
                <div className="p-sm-3">
                    <div>
                        <h3 className="fw-bold">Branches</h3>
                        <div className="row mb-md-0 mb-2">
                            <div className="col-lg-8 col-12 d-md-flex justify-content-between">
                                <Paper
                                    component="form"
                                    sx={{ p: '1px 4px', display: 'flex', alignItems: 'center', width: 380 }}
                                >
                                    <InputBase
                                        sx={{ ml: 1, flex: 1 }}

                                        placeholder="Search Organisation"
                                        inputProps={{ 'aria-label': 'search organizations' }}
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                    <IconButton type="button" sx={{ p: '6px' }} aria-label="search">
                                        <SearchIcon />
                                    </IconButton>
                                </Paper>
                            </div>

                            <div className="col-lg-4 col-12 d-flex justify-content-end gap-2">
                                {admin?.permissions.addOrganization && (
                                    <span className="m-1">
                                        <Link
                                            to={"/admin/AddBranches"}
                                            className="btn text-white"
                                            style={{ backgroundColor: "#003B93", minWidth: "150px" }}
                                        >
                                            <FaPlus /> Add Branches
                                        </Link>
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="w-100 test" style={{ position: 'relative', minHeight: '400px' }}>
                            {loading ? (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                                    <CircularProgress size={50} sx={{ color: '#003B93' }} />
                                </Box>
                            ) : (
                                <TableMuiCustom
                                    styleTableTh={{ fontWeight: "bold" }}
                                    styleTableContainer={{ minWidth: "800px" }}
                                    TableHead={{
                                        borderRadius: "10px",
                                        color: "black",
                                        fontWeight: "bold",
                                    }}
                                    styleTableThead={{
                                        backgroundColor: "white",
                                        color: "black",
                                        fontWeight: "bold",
                                    }}
                                    th={{
                                        index: "ID",
                                        companyName: "Branch Name",
                                        parentOrg: "Operating Company",
                                        BusinessGroupEntity: "Bussiness Group",
                                        ...(admin?.permissions.deleteOrganization && { deleteBtn: "Delete" }),
                                        ...(admin?.permissions.editOrganization && { editBtn: "Edit" }),
                                    }}
                                    td={enrichedOrganizations}
                                    customFields={[
                                        {
                                            name: "companyName",
                                            data: (value, row) => (
                                                <Box className="d-flex justify-content-between align-items-center cursor">
                                                    {row?.companyName}
                                                </Box>
                                            ),
                                        },
                                        {
                                            name: `${admin?.permissions.editOrganization ? "editBtn" : ""}`,
                                            data: (value, row) => (
                                                <Box className="d-flex justify-content-between align-items-center">
                                                    <button
                                                        onClick={() => {
                                                            setNodeData({
                                                                ...row,
                                                                shareHolders: row.shareHolders || [],
                                                                directors: typeof row.directors === 'string' ? row.directors.split(",").filter(d => d.trim()) : [],
                                                            });
                                                            setOpen(true);
                                                            setDeleteopen(false);
                                                            dispatch({
                                                                type: "alertchange", payload: {
                                                                    id: row?.nodeId,
                                                                    message: "Another users also edit this business group"
                                                                }
                                                            })
                                                        }}
                                                        style={{ backgroundColor: "#003B93", color: "white" }}
                                                        className="btn"
                                                    >
                                                        Edit
                                                    </button>
                                                </Box>
                                            ),
                                        },
                                        {
                                            name: "parentOrg",
                                            data: (value, row) => (
                                                <Box className="d-flex justify-content-between align-items-center">
                                                    {row.parentOrg || "N/A"}
                                                </Box>
                                            ),
                                        },

                                        {
                                            name: "location",
                                            data: (value, row) => (
                                                <Box className="d-flex justify-content-between align-items-center">
                                                    {row.location?.address}
                                                </Box>
                                            ),
                                        },
                                        {
                                            name: `${admin?.permissions.deleteOrganization ? "deleteBtn" : ""}`,
                                            data: (value, row) => (
                                                <Box className="d-flex justify-content-between align-items-center">
                                                    <DeleteIcon style={{ fontSize: "30px", color: "#1976d2", cursor: "pointer" }} onClick={() => {
                                                        setnode(row);
                                                        setOpenDeleteModal(true);
                                                        setDeleteopen(true);
                                                    }} />
                                                </Box>
                                            ),
                                        },
                                        {
                                            name: "branchView",
                                            data: (value, row) => (
                                                <Box className="d-flex justify-content-between align-items-center">
                                                    <button
                                                        onClick={() => {
                                                            setshowBranch(true);
                                                            setOpenDeleteModal(false);
                                                            setDeleteopen(false);
                                                            setnode1(row);
                                                        }}
                                                        style={{ backgroundColor: "#003B93", color: "white" }}
                                                        className="btn"
                                                    >
                                                        Branches
                                                    </button>
                                                </Box>
                                            ),
                                        },
                                        {
                                            name: "treeView",
                                            data: () => (
                                                <Box className="d-flex justify-content-between align-items-center">
                                                    <button
                                                        onClick={() => {
                                                            navigate("/admin/Organisational-Chart");
                                                        }}
                                                        style={{ backgroundColor: "#003B93", color: "white" }}
                                                        className="btn"
                                                    >
                                                        Tree View
                                                    </button>
                                                </Box>
                                            ),
                                        },
                                    ]}
                                />
                            )}
                        </div>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                            <Box display="flex" alignItems="center" flexDirection={"column"} gap={2}>
                                <Pagination
                                    count={total === 0 ? 1 : Math.ceil((total || 0) / pageSize) || 1}
                                    page={page}
                                    onChange={(e, value) => setPage(value)}
                                    color="primary"
                                />
                                <Typography variant="body2" color="textSecondary">
                                    Total Branches: {total}
                                </Typography>
                            </Box>
                            <Select
                                value={pageSize}
                                onChange={(e) => { setPageSize(Number(e.target.value)); setPage(1); }}
                                size="small"
                                sx={{
                                    color: "#003B93",
                                    ".MuiOutlinedInput-notchedOutline": { borderColor: "#003B93" },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#003B93" },
                                    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#003B93" },
                                    ".MuiSvgIcon-root": { color: "#003B93" },
                                }}
                            >
                                {[5, 10, 20, 50, 100, 200]?.map((n) => (
                                    <MenuItem key={n} value={n}>{n}</MenuItem>
                                ))}
                            </Select>
                        </Box>
                    </div>
                </div>
                {open && (
                    <EditBranches
                        origin={"parent"}
                        nodeData={nodeData}
                        handleClose={handleClose}
                        open={open}
                        handleChange={handleChange}
                        errors={errors}

                        setErrors={setErrors}
                        handleFileChange={handleFileChange}
                        handleSubmit={handleSubmit}
                        handelDirector={handelDirector}
                        handleShareHolders={handleShareHolders}
                        handelAddShareHolder={handelAddShareHolder}
                        handleAddDirector={handleAddDirector}
                        handleTotalSharesChange={handleTotalSharesChange}
                        enrichedOrganizations={enrichedOrganizations}
                        allorganization1={allorganization}
                        sharedata={sharedata}
                        setSharedata={setSharedata}
                        setNodeData={setNodeData}
                    />
                )}

                {(open && nodeData?.nodeId === warndata?.objId && warndata?.users?.filter((item) => item !== admin?._id + "-" + deviceId).length > 0) && <WarningModal setOpen={setOpen} setNodeData={setNodeData} usersInfo={warndata?.usersInfo || []} users={warndata?.users} nodeId={warndata?.objId} />}

            </div>

            {deleteopen && <DeleteNodeChildModel open={openDeleteModal} setOpenDeleteModal={setOpenDeleteModal1} setNodeData={setNodeData} setshowBranch={setshowBranch} setOpen={setOpen} handleClose={setOpenDeleteModal} node={node} setdatafordelete={setdatafordelete} />}
            <LoadingOverlay open={isUpdating || isDeleting} />
            {deleteopen && <DeleteModal setshowBranch={setshowBranch} setOpenDeleteModal={setOpenDeleteModal1} openDeleteModal={openDeleteModal1} deleteData={deleteData} />}
            <ShowBranchesModel open={showBranch} setOpenDeleteModal={setOpenDeleteModal1} setDeleteopen={setDeleteopen} setnode={setnode1} setNodeData={setNodeData} setOpen={setOpen} handleClose={setshowBranch} node={node1} setnodefordelete={setnode} setdatafordelete={setdatafordelete} />
        </>
    );
}

export default Branches;



